export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de facturas"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de la factura"])},
          "title_invoice_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagos"])},
          "total_number_invoice_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagos"])}
        }
      }
    }
  })
}